export const fontFamilies = {
  roman: { fontFamily: "Helvetica N Roman", fontWeight: 400 },
  medium: { fontFamily: "Helvetica N Medium" },
  heavy: { fontFamily: "Helvetica N Heavy" },
  bold: { fontFamily: "Helvetica N Bold", fontWeight: 700 },
  black: { fontFamily: "Helvetica N Black" },
}
